import Register from '@/pages/Register'

// export default {
//   path: '/register',
//   name: 'register',
//   component: Register
// }

export default {
  path: '/register',
  component: Register,
  children: [
    {
      path: '',
      name: 'register',
      component: Register,
    },
    {
      path: ':ref',
      name: 'RefRegister',
      component: Register,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/register.js